import { atom } from 'recoil';

export const userPageCurrentPageTransferState = atom({
  key: 'userPageCurrentPageTransferState',
  default: {
    countPerPage: 20,
    currentPage: 1,
    exist: false,
    totalCount: '',
  },
});

export const TransferCheckState = atom({
  key: 'TransferCheckState',
  default: { ischecked: 'false' },
});
